import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuard } from '../login/login.guard';
import { AreaComponent } from '../area/area.component';
import {LocationComponent} from '../location/location.component';
import {LocationGeneratorComponent} from '../location-generator/location-generator.component'

const routes: Routes = [
  {
    path: 'area',
    component: AreaComponent,
    canActivate : [LoginGuard]
  },
  {
    path: 'area/locations/:id',
    component: LocationComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'area/locations/generate/:id',
    component: LocationGeneratorComponent,
    canActivate: [LoginGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LocationRoutingModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/location-routing.module.ts